/* tslint:disable */
/* tslint:disable */
/**
 * ClearFlask Admin API
 * ClearFlask API documentation.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/* tslint:disable */
// eslint-disable-next-line no-unused-vars
import { exists } from '../runtime';
/**
 * 
 * @export
 * @interface GitLabGetProjectsBody
 */
export interface GitLabGetProjectsBody {
    /**
     * 
     * @type {string}
     * @memberof GitLabGetProjectsBody
     */
    code: string;
    /**
     * GitLab instance URL (e.g., https://gitlab.com or https://gitlab.mycompany.com). Defaults to https://gitlab.com if not provided.
     * @type {string}
     * @memberof GitLabGetProjectsBody
     */
    gitlabInstanceUrl?: string;
}

export function GitLabGetProjectsBodyFromJSON(json: any): GitLabGetProjectsBody {
    return {
        'code': json['code'],
        'gitlabInstanceUrl': !exists(json, 'gitlabInstanceUrl') ? undefined : json['gitlabInstanceUrl'],
    };
}

export function GitLabGetProjectsBodyToJSON(value?: GitLabGetProjectsBody): any {
    if (value === undefined) {
        return undefined;
    }
    return {
        'code': value.code,
        'gitlabInstanceUrl': value.gitlabInstanceUrl,
    };
}


